import { Button } from "@mui/material";
import React, { useState } from "react";
import css from "./styles.module.scss";

const LinkOfferCreate = () => {
  const [valueTextArea, setValueTextArea] = useState("1\\\n2\\\n3\\\n");
  const [link, setLink] = useState<string>("");
  const [resultArray, setResultArray] = useState<any>([]);

  const getArray = () => {
    let temp = valueTextArea.split("\\");
    let temp2 = temp.map(
      (item) =>
        item !== "" && [
          `${link}${item
            .replace("\n", "")
            .replace("\\", "")}/?track_id={trkId}`,
          `${link}${item.replace("\n", "").replace("\\", "")}/`,
          `${link}${item
            .replace("\n", "")
            .replace("\\", "")}/?track_url={trackLink}`,
        ]
    );
    setResultArray(temp2);
  };

  return (
    <div className={css.LinkOfferCreate}>
      <div className={css.LinkOfferCreate_form}>
      <label htmlFor="">Введите ссылку на папку на сервере</label>
      <span className={css.info}>Например: https://acustal.fair-2sale.com/pl/</span>
      <input
        type="text"
        value={link}
        onChange={(e) => {
          setLink(e.target.value);
        }}
        placeholder="Введите ссылку"
        required
      />
      <label htmlFor="">Добавьте списком имена папок</label>
      <div className={css.list}>
        <span>Например:</span>
        <br />
        <span>1\</span>
        <span>2\</span>
        <span>3\</span>
      </div>
      <textarea
        rows={10}
        cols={50}
        value={valueTextArea}
        onChange={(e) => setValueTextArea(e.target.value)}
        style={{
          width: "100%",
          height: "150px",
        }}
      ></textarea>
      <Button variant="outlined" size="small" onClick={getArray}>
        Сгенерировать
      </Button>
      </div>
      <div className={css.result}>
        {resultArray.map((item: any) => (
          <div
            style={{
              marginBottom: "25px",
            }}
          >
            {item && item.map((el: any) => <div key={el}>{el}</div>)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LinkOfferCreate;
